import { coreFeatures } from '@/mocks/site';

export default function FeatureSection() {
  return (
    <section className="py-20 md:py-28 px-6 bg-background-50">
      <div className="mx-auto" style={{ maxWidth: 1280 }}>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            核心功能
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            一站式资源服务平台
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            四大核心功能模块，为您提供全方位的资源整合与便捷服务体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {coreFeatures.map((feature, index) => (
            <div
              key={feature.id}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}